<template>
  <form @submit.prevent="validateBeforeSubmit" class="row ls-form">
    <div class="container-fluid">
      <div class="col-md-8 col-lg-8 col-xs-12 col-sm-12">
        <div class="row ls-lg-margin-bottom">
          <h3 class="ls-title-4">{{ $t('customers.main.customer_information') }}</h3>
        </div>
        <div class="row">
          <MaterialInput
            type="email"
            label="Email"
            ref="email"
            ico="fa fa-envelope-o"
            focused="true"
            data-vv-name="email"
            v-validate="'required|email|emailInUse'"
            v-model="$parent.$data.email"
            :class="{ 'material--active material--has-errors': errors.has('email')}">
            {{ $t('customers.attributes.email') }}
            <small class="material-errors" slot="help-message-email" v-if="errors.has('email')">{{ errors.first('email') }}</small>
            <i class="fa fa-check" slot="ico-check-email" aria-hidden="true" v-if="!errors.has('email') && $parent.$data.email"></i>
          </MaterialInput>
          <MaterialInput
            type="password"
            ico="fa fa-lock"
            label="Password"
            v-if="!$parent.$data.id"
            v-model="$parent.$data.password"
            v-validate="'required|min:6'"
            :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.password')) }"
            :data-vv-name="$t('customers.attributes.password')">
            {{ $t('customers.attributes.password') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.password'))">{{ errors.first($t('customers.attributes.password')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.password')) && $parent.$data.password" aria-hidden="true"></i>
          </MaterialInput>

          <MaterialInput
            type="tel"
            ico="fa fa-phone"
            maxlength="16"
            v-model="$parent.$data.fullPhone"
            v-validate="'phone|required'"
            :v-mask="$parent.$data.phoneMask"
            :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.phone')) }"
            :data-vv-name="$t('customers.attributes.phone')">
            {{ $t('customers.attributes.phone') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.phone'))">{{ errors.first($t('customers.attributes.phone')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.phone')) && $parent.$data.fullPhone" aria-hidden="true"></i>
          </MaterialInput>
        </div>

        <div class="row">
          <label class="ls-label ls-no-bold ls-text-xs ls-lg-margin-bottom">
            <input type="checkbox" name="business_people" v-model="$parent.$data.isBusiness" :disabled="$parent.$data.lockBusiness"> {{ $t('customers.main.register_as_legal_entity') }}
          </label>
        </div>


        <div class="row" v-if="$parent.$data.isBusiness">
          <MaterialInput
            type="text"
            ico="fa fa-building-o"
            focused="true"
            v-validate="'required'"
            v-model="$parent.$data.companyName"
            :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.company_name')) }"
            :data-vv-name="$t('customers.attributes.company_name')"
            :required="false">
            {{ $t('customers.attributes.company_name') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.company_name'))">{{ errors.first($t('customers.attributes.company_name')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.company_name')) && $parent.$data.company_name" aria-hidden="true"></i>
          </MaterialInput>

          <MaterialInput
            type="text"
            ico="fa fa-briefcase"
            focused="true"
            v-validate="'required'"
            v-model="$parent.$data.tradeName"
            :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.trade_name')) }"
            :data-vv-name="$t('customers.attributes.trade_name')"
            >
            {{ $t('customers.attributes.trade_name') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.trade_name'))">{{ errors.first($t('customers.attributes.trade_name')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.trade_name')) && $parent.$data.tradeName" aria-hidden="true"></i>
          </MaterialInput>

          <MaterialInput
            type="tel"
            ico="fa fa-id-card"
            maxlength="18"
            v-mask="'99.999.999/9999-99'"
            v-validate="'required|cnpj'"
            v-model="$parent.$data.cnpj"
            :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.cnpj')) }"
            :data-vv-name="$t('customers.attributes.cnpj')"
            :required="false">
            {{ $t('customers.attributes.cnpj') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.cnpj'))">{{ errors.first($t('customers.attributes.cnpj')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.cnpj')) && $parent.$data.cnpj" aria-hidden="true"></i>
          </MaterialInput>

          <h3 class="ls-lg-margin-bottom">{{ $t('customers.main.optional_personal_info') }}</h3>

          <div>
            <MaterialInput
              type="tel"
              maxlength="14"
              focused="true"
              ico="fa fa-id-card-o"
              :required="false"
              v-mask="'999.999.999-99'"
              v-model="$parent.$data.cpf"
              v-validate="'min:14|cpf|cpfInUse'"
              :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.cpf')) }"
              :data-vv-name="$t('customers.attributes.cpf')">
              {{ $t('customers.attributes.cpf') }}
              <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.cpf'))">{{ errors.first($t('customers.attributes.cpf')) }}</small>
              <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.cpf')) && $parent.$data.cpf" aria-hidden="false"></i>
            </MaterialInput>

            <MaterialInput
              type="text"
              label="Name"
              ico="fa fa-user-o"
              :required="false"
              v-validate="'alpha_spaces|min:2'"
              v-model="$parent.$data.name"
              :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.name')) }"
              :data-vv-name="$t('customers.attributes.name')">
              {{ $t('customers.attributes.name') }}
              <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.name'))">{{ errors.first($t('customers.attributes.name')) }}</small>
              <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.name')) && $parent.$data.name" aria-hidden="true"></i>
            </MaterialInput>
          </div>
        </div>
        <div class="row">
          <MaterialInput
            type="tel"
            maxlength="14"
            focused="true"
            v-if="!$parent.$data.isBusiness"
            ico="fa fa-id-card-o"
            v-mask="'999.999.999-99'"
            v-model="$parent.$data.cpf"
            v-validate="'required|min:14|cpf|cpfInUse'"
            :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.cpf')) }"
            :data-vv-name="$t('customers.attributes.cpf')">
            {{ $t('customers.attributes.cpf') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.cpf'))">{{ errors.first($t('customers.attributes.cpf')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.cpf')) && $parent.$data.cpf" aria-hidden="false"></i>
          </MaterialInput>

          <MaterialInput
            type="text"
            label="Name"
            ico="fa fa-user-o"
            v-if="!$parent.$data.isBusiness"
            v-validate="'alpha_spaces|min:2'"
            v-model="$parent.$data.name"
            :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.name')) }"
            :data-vv-name="$t('customers.attributes.name')">
            {{ $t('customers.attributes.name') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.name'))">{{ errors.first($t('customers.attributes.name')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.name')) && $parent.$data.name" aria-hidden="true"></i>
          </MaterialInput>
        </div>
      </div>

      <div class="col-md-1 col-lg-1"></div>

      <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12">
        <div class="row d-flex align-items-center ls-lg-margin-bottom">
          <h3 class="ls-title-4">{{ $t('customers.main.customer_location') }}</h3>
        </div>
        <div class="row d-flex align-items-center">
          <MaterialInput
            type="tel"
            maxlength="10"
            ico="fa fa-map-pin"
            v-mask="'99.999-999'"
            v-model="$parent.$data.postalCode"
            v-validate="'required|min:10|cep'"
            :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.address.postal_code')) }"
            :data-vv-name="$t('customers.attributes.address.postal_code')">
            {{ $t('customers.attributes.address.postal_code') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.address.postal_code'))">{{ errors.first($t('customers.attributes.address.postal_code')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="showAddressDetails" aria-hidden="true"></i>
          </MaterialInput>

          <div class="col-xs-6 col-sm-6 col-md-12 margin-postal-code">
            <p><a href="http://www.buscacep.correios.com.br/sistemas/buscacep/" target="_blank">{{ $t('settings.main.forgot_zipcode') }}</a></p>
          </div>
        </div>

        <div v-if="showAddressDetails">
          <div class="row d-flex align-items-center">
            <div class="col-md-8 col-xs-8 col-sm-8 ls-no-padding">
              <MaterialInput
                type="text"
                ico="fa icon icon-house"
                v-model="$parent.$data.street"
                v-validate="'required'"
                :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.address.street')) }"
                :data-vv-name="$t('customers.attributes.address.street')"
                :focused="focusStreet">
                {{ $t('customers.attributes.address.street') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.address.street'))">{{ errors.first($t('customers.attributes.address.street')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.address.street')) && $parent.$data.street.length" aria-hidden="true"></i>
              </MaterialInput>
            </div>
            <div class="col-md-4 col-xs-4 col-sm-4 ls-no-padding-right">
              <MaterialInput
                type="tel"
                maxlength="10"
                v-validate="'required|numeric'"
                v-model="$parent.$data.number"
                ico="fa icon icon-number"
                :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.address.number')) }"
                :data-vv-name="$t('customers.attributes.address.number')"
                :focused="focusNumber">
                {{ $t('customers.attributes.address.number') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.address.number'))">{{ errors.first($t('customers.attributes.address.number')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.address.number')) && $parent.$data.number.length" aria-hidden="true"></i>
              </MaterialInput>
            </div>
          </div>

          <div class="ls-clearfix"></div>

          <div class="row">
            <MaterialInput
              type="tel"
              ico="fa icon icon-neighborhood"
              v-validate="'required'"
              v-model="$parent.$data.neighborhood"
              :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.address.neighborhood')) }"
              :data-vv-name="$t('customers.attributes.address.neighborhood')"
              :focused="focusNeighborhood">
              {{ $t('customers.attributes.address.neighborhood') }}
              <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.address.neighborhood'))">{{ errors.first($t('customers.attributes.address.neighborhood')) }}</small>
              <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.address.neighborhood')) && $parent.$data.neighborhood.length" aria-hidden="true"></i>
            </MaterialInput>
          </div>

          <div class="row">
            <MaterialInput
              type="text"
              name="complement"
              v-model="$parent.$data.complement"
              ico="fa icon icon-cityscape"
              :required="false">
              {{ $t('customers.attributes.address.complement') }}
            </MaterialInput>
          </div>

          <div class="row d-flex align-items-center">
            <div class="col-md-8 col-sm-8 col-xs-8 ls-no-padding">
              <MaterialInput
                type="text"
                ico="fa icon icon-cityscape"
                v-validate="'required'"
                v-model="$parent.$data.city"
                :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.address.city')) }"
                :data-vv-name="$t('customers.attributes.address.city')"
                :focused="focusCity">
                {{ $t('customers.attributes.address.city') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.address.city'))">{{ errors.first($t('customers.attributes.address.city')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.address.city')) && $parent.$data.city.length" aria-hidden="true"></i>
              </MaterialInput>
            </div>

            <div class="col-md-4 col-xs-4 col-sm-4 ls-no-padding-right">
              <MaterialInput
                type="select"
                v-validate="'required'"
                v-model="$parent.$data.state"
                ico="fa icon icon-state"
                :focused="focusState"
                :class="{ 'material--active material--has-errors': errors.has($t('customers.attributes.address.state')) }"
                :data-vv-name="$t('customers.attributes.address.state')">
                {{ $t('customers.attributes.address.state') }}
                <option slot="options" value="AC">AC</option>
                <option slot="options" value="AL">AL</option>
                <option slot="options" value="AP">AP</option>
                <option slot="options" value="AM">AM</option>
                <option slot="options" value="BA">BA</option>
                <option slot="options" value="CE">CE</option>
                <option slot="options" value="DF">DF</option>
                <option slot="options" value="ES">ES</option>
                <option slot="options" value="GO">GO</option>
                <option slot="options" value="MA">MA</option>
                <option slot="options" value="MS">MS</option>
                <option slot="options" value="MG">MG</option>
                <option slot="options" value="MT">MT</option>
                <option slot="options" value="PA">PA</option>
                <option slot="options" value="PB">PB</option>
                <option slot="options" value="PR">PR</option>
                <option slot="options" value="PE">PE</option>
                <option slot="options" value="PI">PI</option>
                <option slot="options" value="RJ">RJ</option>
                <option slot="options" value="RN">RN</option>
                <option slot="options" value="RS">RS</option>
                <option slot="options" value="RO">RO</option>
                <option slot="options" value="RR">RR</option>
                <option slot="options" value="SC">SC</option>
                <option slot="options" value="SP">SP</option>
                <option slot="options" value="SE">SE</option>
                <option slot="options" value="TO">TO</option>
                <small class="material-errors" slot="help-message" v-if="errors.has($t('customers.attributes.address.state'))">{{ errors.first($t('customers.attributes.address.state')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('customers.attributes.address.state')) && $parent.$data.state.length" aria-hidden="true"></i>
              </MaterialInput>
            </div>
          </div>
          <div class="ls-clearfix"></div>
        </div>
      </div>
      <div class="ls-clearfix"></div>
      <div class="ls-actions-btn">
        <div class="ls-float-right">
          <router-link to="/" class="ls-btn">{{ $t('application.button.cancel') }} </router-link>
          <button type="submit" class="ls-btn ls-btn-primary">{{ $t('application.button.save') }}</button>
        </div>
        <div class="ls-clearfix"></div>
      </div>
    </div>
  </form>
</template>
<script>
  import MaterialInput from '../../../components/shareds/MaterialInput.vue'
  import { mapActions, mapGetters } from 'vuex'
  import * as format from 'src/utils/form'

  export default {
    components: { MaterialInput },
    methods: {
      ...mapActions(['createCustomerWithoutLogin', 'updateCustomerWithoutLogin', 'getAddress']),
      validateBeforeSubmit () {
        this.$loader.show()
        this.$validator.validate().then(this.afterValidate)
      },
      afterValidate (response) {
        if (response === false) {
          this.$loader.hide()
          return
        }
        this.parseCustomerAttributes()
        this.createOrUpdate().then(this.afterSave)
      },
      afterSave (response) {
        window.localStorage.removeItem('customerEmail')
        window.localStorage.removeItem('customerCPF')
        if (this.$parent.createByContract || this.$parent.updateByContract) {
          this.$router.push({ path: 'contracts/new', name: 'contracts_new', params: { customer: response.data.customer } })
        } else {
          this.$router.push('/customers')
        }
        this.$loader.hide()
      },
      createOrUpdate () {
        if (this.$parent.$data.edit) {
          return Promise.resolve(this.updateCustomerWithoutLogin(this.$parent.$data.parsedCust))
        } else {
          return Promise.resolve(this.createCustomerWithoutLogin(this.$parent.$data.parsedCust))
        }
      },
      clearBusinessFields () {
        this.$parent.$data.kind = 'C'

        if (this.isBusiness) return
        this.$parent.$data.cnpj = ''
        this.$parent.$data.tradeName = ''
        this.$parent.$data.kind = 'P'
      },
      // Metodos para formatacao
      formatFields () {
        this.formatPhone()
        this.formatCpf()
        this.formatCnpj()
      },
      formatPhone () {
        if (!this.$parent.$data.fullPhone) return
        this.$parent.$data.fullPhone = format.formatPhone(this.$parent.$data.fullPhone)
      },
      formatCpf () {
        if (this.$parent.$data.cpf) this.$parent.$data.cpf = format.cpf(this.$parent.$data.cpf)
      },
      formatCnpj () {
        if (this.$parent.$data.cnpj) this.$parent.$data.cnpj = format.cnpj(this.$parent.$data.cnpj)
      },

      // Metodo responsavel por montar os atributos do customer de forma correta
      parseCustomerAttributes () {
        this.initializeParsedCust()
        if (this.$parent.$data.fullPhone.length > 0) this.parseContact()
        this.parseAddress()
        this.parseCustAttributes()
      },
      // Inicializa o processo de modelagem dos dados do customer
      initializeParsedCust () {
        this.$parent.$data.parsedCust = {
          contact_attributes: {},
          address_attributes: {}
        }
      },
      // Modela os atributos de endereco do customer
      parseAddress () {
        this.$parent.$data.parsedCust.address_attributes.postal_code = this.$parent.$data.postalCode.replace(this.$parent.$data.onlyNumber, '')
        this.$parent.$data.parsedCust.address_attributes.complement = this.$parent.$data.complement
        this.$parent.$data.parsedCust.address_attributes.neighborhood = this.$parent.$data.neighborhood
        this.$parent.$data.parsedCust.address_attributes.street = this.$parent.$data.street
        this.$parent.$data.parsedCust.address_attributes.number = this.$parent.$data.number
        this.$parent.$data.parsedCust.address_attributes.city = this.$parent.$data.city
        this.$parent.$data.parsedCust.address_attributes.state = this.$parent.$data.state
      },
      // Modela os atributos de contato do customer
      parseContact () {
        let phoneNumber = this.$parent.$data.fullPhone.replace(this.$parent.$data.onlyNumber, '')
        this.$parent.$data.parsedCust.contact_attributes.area_code = phoneNumber.substring(0, 2)
        this.$parent.$data.parsedCust.contact_attributes.number = phoneNumber.substring(2)
        if (this.$parent.$data.contactId) this.$parent.$data.parsedCust.contact_attributes.id = this.contactId
      },
      // Modela os atributos pessoais do customer
      parseCustAttributes () {
        this.$parent.$data.parsedCust.name = this.$parent.$data.name
        this.$parent.$data.parsedCust.email = this.$parent.$data.email
        this.$parent.$data.parsedCust.id = this.$parent.$data.id
        this.$parent.$data.parsedCust.cpf = this.$parent.$data.cpf.replace(this.$parent.$data.onlyNumber, '')
        this.$parent.$data.parsedCust.create_password_by_email = true
        if (this.$parent.$data.isBusiness) {
          this.$parent.$data.parsedCust.cnpj = this.$parent.$data.cnpj.replace(this.$parent.$data.onlyNumber, '')
          this.$parent.$data.parsedCust.kind = 'C'
          this.$parent.$data.parsedCust.trade_name = this.$parent.$data.tradeName
          this.$parent.$data.parsedCust.company_name = this.$parent.$data.companyName
        } else {
          this.$parent.$data.parsedCust.kind = 'P'
          this.$parent.$data.parsedCust.cnpj = null
        }
      },
      emptyField (field) {
        return (!this.$parent.$data[field] || this.$parent.$data[field].length === 0)
      }
    },
    computed: {
      ...mapGetters(['addressFound']),
      showAddressDetails () {
        return !this.errors.has(this.$t('customers.attributes.address.postal_code')) && this.$parent.$data.postalCode && this.$parent.$data.cepFound
      },
      focusStreet () {
        return (this.emptyField('street')).toString()
      },
      focusNumber () {
        return (!this.emptyField('street') && this.emptyField('number')).toString()
      },
      focusNeighborhood () {
        return (!this.emptyField('street') && !this.emptyField('number') && this.emptyField('neighborhood')).toString()
      },
      focusCity () {
        return (!this.emptyField('street') && !this.emptyField('number') && !this.emptyField('neighborhood') &&
          this.emptyField('city')).toString()
      },
      focusState () {
        return (!this.emptyField('street') && !this.emptyField('number') && !this.emptyField('neighborhood') &&
          !this.emptyField('city') && this.emptyField('state')).toString()
      }
    },
    watch: {
      addressFound: function (value) {
        if (!value.address) {
          this.$loader.hide()
          return
        }
        if (!this.$parent.$data.changeAddress) return
        this.$parent.$data.street = value.address.street || ''
        this.$parent.$data.number = value.address.number || ''
        this.$parent.$data.neighborhood = value.address.neighborhood || ''
        this.$parent.$data.complement = value.address.complement || ''
        this.$parent.$data.city = value.address.city || ''
        this.$parent.$data.state = value.address.state || ''
        this.$parent.$data.changeAddress = false
        this.$parent.$data.cepFound = true
        this.$loader.hide()
      },
      '$parent.$data.fullPhone': function () {
        let phone = this.$parent.$data.fullPhone.replace(this.$parent.$data.onlyNumber, '')
        if (this.$parent.$data.fullPhone === undefined || phone.length <= 10) {
          this.$parent.$data.phoneMask = '(99) 9999-99999'
        } else {
          this.$parent.$data.phoneMask = '(99) 9 9999-9999'
        }
      },
      '$parent.$data.postalCode': function (newVal, oldVal) {
        if (this.$parent.$data.edit) return

        this.$parent.$data.cepFound = false

        if (newVal === oldVal) {
          this.$parent.$data.changeAddress = false
        } else {
          this.$parent.$data.changeAddress = true
          if (newVal.length === 10) this.$loader.show()
        }
      }
    }
  }
</script>
<style>
  .d-flex {
    display: flex;
  }
  .align-items-center {
    align-items: center;
  }
</style>




// WEBPACK FOOTER //
// Form.vue?418fd4be